export enum MsgToParentPage {
	GetToken = 'getToken',
	SetToken = 'setToken',
	ClearToken = 'clearToken',
}
